import { runningAppRelease } from '@/utils/running-app-release'

/** Returns the version of the executing bundle, never the server's newer release. */
export async function fetchPublicAppVersion(): Promise<string> {
  return runningAppRelease.version
}
